export default {
    namespaced: true,
    chatbot_fake: {
      section_master_account: "Claro, te dirijo a la vista para que puedas agregar la cuenta maestra",
      default_final_response: "Aqui tienes el resultado:",
      welcome: "Hola, soy Omniview AI, ¿En qué puedo ayudarte?",
      sugestion_options: "Puedo sugerirte las siguientes opciones:",
      create_chart_bar: "Crear chart tipo bar",
      create_chart_pie: "Crear chart tipo pie",
      create_list: "Crear chart lista",
      List: "lista",
      type_event_select: "Selecciona el tipo de evento que quiere consultar",
      type_event: {
        select: "Selecciona el tipo de evento que quiere consultar",
        alarms: "Alarms",
        camera: "Camera",
        detection_events: "Eventos de detección",
      },
      select_type_group: "Selecciona tipo de agrupamiento",
      type_group_alarms: {
        status: "Estatus",
        type: "Tipo de alarma",
        tenant: "Tenant",
      },
      type_group_camera: {
        status: "Estatus",
        tenant: "Tenant",
        center: "Centro",
        sector: "Sector",
      },
      type_group_detection_events: {
        type: "Tipo de Evento"
      },
      sugestion_filters: "Te puedo sugerir los siguientes filtros",
      sugestion_filters_metadata: "Te puedo sugerir los siguientes filtros por metadata",
      metadataOption: "¿Qué filtros te gustaría aplicar?",
      tipCard: "Arrastra esta card a alguna tab",
      ready: "Listo",
      pieName: "Chart dona",
      barName: "Chart barra",
      mapName: "Mapa",
      listName: "Lista"
    }
  };  